import {Component, Inject, Input} from '@angular/core';
import {AcDialog, AcDialogComponent, DIALOG_CONFIG, DialogConfig, GeneralService, PromiseService} from 'ac-infra';
import {FileSelectionService} from '../../common/components/file-selection/file-selection.service';
import * as _ from 'lodash';

@AcDialog({
    id: 'multi-login-operator-dialog-id',
    cancelButtonText: 'Logout',
    noSubmitButton: true,
    width: 600,
    title: 'Choose Permission Level'
})
@Component({
    selector: 'multi-login-operator-dialog',
    templateUrl: './multi-login-operator-dialog.component.html',
    styleUrls: ['./multi-login-operator-dialog.component.less'],
})
export class MultiLoginOperatorDialogComponent {

    @Input() showTree = true;

    entities;
    searchedEntities;

    statusColors = GeneralService.statusColors;
    typeOrder = { tenant: 1, channel: 2, customer: 3 };

    constructor(@Inject(DIALOG_CONFIG) public dialogConfig: DialogConfig,
                private acDialogComponent: AcDialogComponent,
                private fileSelectionService: FileSelectionService) {}

    ngOnInit() {
        this.entities = this.dialogConfig.dialogData.entities;

        this.entities = _.orderBy(this.entities, [item => this.typeOrder[item.entityType], item => item.name.toLowerCase()], ['asc', 'asc']);

        this.handleLogo();
    }

    handleLogo = () => {
        this.entities.forEach((entity) => {
            if(entity.entityType.toLowerCase() === 'customer'){
                const tenant = this.getParentByType(entity, 'tenant');
                const channel = this.getParentByType(entity, 'channel');

                const logoObject = entity?.logoId === -1 ? (!channel || channel.logoId === -1 ? tenant : channel) : entity;
                this.fetchLogo(entity, logoObject);
            }else if(entity.entityType.toLowerCase() === 'channel'){
                const tenant = this.getParentByType(entity, 'tenant');
                const logoObject = entity?.logoId === -1 ? tenant : entity;
                this.fetchLogo(entity, logoObject);
            }else{
                this.fetchLogo(entity);
            }
        });
    }

    getParentByType = (entity, type) => {
        return entity?.parents?.find(parent => parent.entityType.toLowerCase() === type);
    }

    fetchLogo = (entity, parent = undefined) => {
        const logoObj = entity.logoId === -1 ? parent : entity;
        if(!logoObj || logoObj.logoId === -1){
            entity.logo = -1;
        }else{
            this.fileSelectionService.getLogoImage(logoObj, 'logoId').then((responseImage) => {
                entity.logo = responseImage === -1 ? -1 : responseImage;
            }).catch((error) => {
                entity.logo = -1;
            });
        }
    };

    entitySelectionChanged = (selection) => {
        this.dialogConfig.dialogData.entity = _.cloneDeep(selection);

        this.acDialogComponent.onSubmit();
    };

    searchEvent = (search) => {
        this.searchedEntities = search ? this.entities.filter((entity) => {
            return (entity.name).toLowerCase().includes(search.toLowerCase());
        }) : this.entities;
    };
}


